import { Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";

import { BaseComponent, UserService, EventBusService } from "@mypxplat/xplat/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: "myp-missed-payment-modal",
  templateUrl: "missed-payment-modal.component.html",
  standalone: false,
})
export class MissedPaymentModalComponent extends BaseComponent {
  @Input() missedPaymentDetails: any;
  @Input() type: any = "missed payment";

  constructor(
    userService: UserService,
    private _eventBus: EventBusService,
    public activeModal: NgbActiveModal
  ) {
    super(userService);
  }
  ngOnInit() {}
}
